<div id="la-container">
  <router-outlet></router-outlet>
</div>
